import { FieldSizes } from './shared';
/**
 * Styles override for the Fluent `TextField` component.
 */
export const textfieldStyles = theme => ({
    root: {
        maxWidth: FieldSizes.short,
        width: '100%',
        '&.ms-TextField--multiline': {
            maxWidth: FieldSizes.multiline,
        },
    },
    fieldGroup: {
        border: '1px solid #797474',
    },
});
